import EventBus from 'event_bus'

export default class Headline {
  constructor ($el, eventNameSpace) {
    this.$el = $el
    this.eventNameSpace = eventNameSpace
    this.addEventHandlers()
  }

  addEventHandlers () {
    EventBus.on(`${this.eventNameSpace}:headline`, this.onEvent.bind(this))
  }

  onEvent (_event, data) {
    this.$el.html(data)
  }
}
